import { useEffect, useState } from 'react';
import { isBgmEnabled, setBgmEnabled, syncBgmPlayback } from '../timer/audio';

export function BgmToggle() {
  const [enabled, setEnabled] = useState<boolean>(() => isBgmEnabled());

  useEffect(() => {
    void syncBgmPlayback();
  }, []);

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    setBgmEnabled(next);
  };

  return (
    <button
      type="button"
      className="mute-toggle"
      aria-label={enabled ? '关闭背景音乐' : '开启背景音乐'}
      aria-pressed={enabled}
      data-enabled={enabled ? 'true' : 'false'}
      title={enabled ? '背景音乐已开 — 点击关闭' : '背景音乐已关 — 点击开启'}
      onClick={toggle}
    >
      <svg className="music-toggle-icon" viewBox="0 0 48 42" aria-hidden="true">
        <g className="music-note-shape note-one">
          <path d="M16 28V10l18-3v18" />
          <circle cx="12" cy="29" r="5" />
          <circle cx="30" cy="26" r="5" />
        </g>
      </svg>
    </button>
  );
}
